module.exports = " <li v-link=\"{ name: 'exercise', params: { id: this.id }}\" class=exercise transition=reveal _v-1a8c0ede=\"\"> {{title}} </li> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-1a8c0ede!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Exercise.vue
// module id = 748
// module chunks = 2